<script>
export default {
  name: 'MkLink',
};
</script>

<template>
  <span v-bind="$attrs" class="mk-link" @click="$emit('click')">
    <slot></slot>
  </span>
</template>

<style scoped lang="less">
@import '../../assets/css/main.less';
.mk-link {
  cursor: pointer;
  color: @app-color;
}
</style>
